module.exports = __webpack_public_path__ + "img/img26.3d7ce7c3.svg";